import React, { useEffect, useRef } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import analytics from "../../services/analytics";

const CheckoutCancel = ({ plan, interval }) => {
  const navigate = useNavigate();
  const [, setSearchParams] = useSearchParams();
  const trackedRef = useRef(false);

  useEffect(() => {
    if (trackedRef.current) return;
    trackedRef.current = true;
    analytics.trackCheckoutCancelled({ plan, interval, flow: "wizard" });
  }, [plan, interval]);

  const handleTryAgain = () => {
    // Remove checkout param to restart the flow
    setSearchParams({ plan, interval });
  };

  return (
    <div className="w-full max-w-md mx-auto">
      <div className="bg-white/80 dark:bg-zinc-900/80 backdrop-blur-sm rounded-2xl border border-gray-200 dark:border-zinc-800 p-8 text-center">
        {/* Icon */}
        <div className="w-14 h-14 mx-auto rounded-2xl bg-gray-100 dark:bg-zinc-800 border border-gray-200 dark:border-zinc-700 flex items-center justify-center mb-5">
          <svg className="w-7 h-7 text-gray-400 dark:text-zinc-500" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
            <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
          </svg>
        </div>

        <h2 className="text-xl font-semibold text-gray-800 dark:text-zinc-100 mb-2">
          Checkout cancelled
        </h2>
        <p className="text-sm text-gray-500 dark:text-zinc-400 leading-relaxed mb-6">
          No worries — nothing was charged. You can try again whenever you're ready.
        </p>

        <div className="space-y-3">
          <button
            onClick={handleTryAgain}
            className="w-full py-2.5 px-4 bg-gradient-to-r from-blue-400 via-cyan-400 to-purple-400 text-black font-bold text-sm rounded-xl hover:shadow-xl hover:scale-[1.02] focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-400/50 transition-all duration-300 active:scale-[0.98] border border-blue-300/50"
          >
            Try again
          </button>

          <button
            onClick={() => navigate("/plans")}
            className="w-full py-2.5 px-4 text-sm font-medium text-gray-600 dark:text-zinc-400 hover:text-gray-800 dark:hover:text-zinc-200 bg-gray-100 dark:bg-zinc-800 hover:bg-gray-200 dark:hover:bg-zinc-700 rounded-xl border border-gray-200 dark:border-zinc-700 transition-all duration-200"
          >
            View all plans
          </button>
        </div>
      </div>
    </div>
  );
};

export default CheckoutCancel;
